var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDraw(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 515,
    height: 512,
    viewBox: "0 0 515 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_906_182)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M503.813 469L476.801 400.909C476.801 400.909 506.513 425.727 506.513 446.091L501.18 399C501.18 399 516.417 416.182 514.893 442.273C513.369 468.364 503.813 469 503.813 469Z",
    fill: "#6C2A77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.1246 449L49.1125 381.882C49.1125 381.882 78.824 406.345 78.824 426.418L73.4912 380C73.4912 380 88.7278 396.936 87.2041 422.655C85.6804 448.373 76.1246 449 76.1246 449Z",
    fill: "#6C2A77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.218 479.376C495.264 523.353 389.408 509.826 259.815 509.918C130.222 510.01 25.9665 523.687 25.9204 479.71C25.8744 435.733 131.692 426.093 261.285 426.001C390.878 425.908 495.172 435.399 495.218 479.376Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.533 466C271.915 466 306.271 437.794 306.271 403C306.271 368.206 271.915 340 229.533 340C187.152 340 152.795 368.206 152.795 403C152.795 437.794 187.152 466 229.533 466Z",
    fill: "#6C2A77"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.396 336C167.755 336.001 157.342 333.471 148.417 328.717C139.492 323.962 132.438 317.188 128.109 309.213L6.27594 84.1146C2.24017 76.6582 0.105733 68.6034 0.00382958 60.4453C-0.0980735 52.2872 1.83471 44.1983 5.68337 36.6756C9.53203 29.1529 15.2153 22.3554 22.3837 16.701C29.5522 11.0466 38.0545 6.65468 47.3679 3.79525C56.6813 0.935826 66.6091 -0.33072 76.5411 0.0734781C86.4731 0.477676 96.1994 2.54407 105.122 6.14565C114.045 9.74723 121.976 14.8079 128.427 21.0166C134.878 27.2253 139.713 34.4508 142.636 42.2491L230.858 277.668C233.383 284.407 233.947 291.537 232.505 298.487C231.062 305.437 227.653 312.012 222.551 317.685C217.449 323.358 210.797 327.97 203.128 331.151C195.46 334.332 186.988 335.992 178.396 336Z",
    fill: "#6C2A77"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_906_182"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 515,
    height: 512,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDraw);
export default __webpack_public_path__ + "static/media/draw.346b2039fc4daf2078fe75cf6f979196.svg";
export { ForwardRef as ReactComponent };